import { useState } from 'react';
import { Tabs } from '@/components/ui/Tabs';
import { GeneralTab } from '@/components/settings/GeneralTab';
import { AutobuyTab } from '@/components/settings/AutobuyTab';

type Tab = 'general' | 'autobuy';

export function SettingsScreen() {
  const [tab, setTab] = useState<Tab>('general');
  return (
    <div
      className="flex-1 overflow-y-auto pb-24 px-4 pt-4 space-y-4"
      style={{ paddingTop: 'calc(env(safe-area-inset-top) + 1rem)' }}
    >
      <h1 className="font-display text-2xl text-white">Настройки</h1>
      <Tabs<Tab>
        tabs={[
          { id: 'general', label: '⚙ Общие' },
          { id: 'autobuy', label: '🤖 Автомат' },
        ]}
        active={tab}
        onChange={setTab}
      />
      {tab === 'general' ? <GeneralTab /> : <AutobuyTab />}
    </div>
  );
}
